module.exports = __webpack_public_path__ + "static/media/search.a728870a.svg";